"use client";

import React from "react";

import { useWeb3DebugContext } from "@/components/Web3/Debug/State";
import { SupText } from "@repo/core-ui";
import { SupCopy } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface Web3DebugCopyButtonProps {
  text?: string;
  className?: string;
}

export default function Web3DebugCopyButton({ text = "Copy debug data", className = "" }: Web3DebugCopyButtonProps) {
  const { copyDebugSummary } = useWeb3DebugContext();

  return (
    <SupText
      as="small"
      className={twMerge("mt-1 inline-flex w-full cursor-pointer items-center justify-end space-x-1 text-error-925 underline hover:no-underline", className)}
      variant="caption"
      onClick={copyDebugSummary}
    >
      <span>{text}</span>
      <SupCopy className="h-4 w-4 lg:group-hover:scale-125" />
    </SupText>
  );
}
